import React, { useState, useEffect, useRef } from 'react';
import './orders.css';
import { BreadCrumb } from 'primereact/breadcrumb';
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import Form from 'react-bootstrap/Form';
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Dialog } from 'primereact/dialog';
import moment from 'jalali-moment';
import { Toast } from 'primereact/toast';
import Loader from '../loader/loader'
import Factor from '../../assets/icons/order/factor.svg';
import Calendar from '../../assets/icons/order/calendar.svg';
import Box from '../../assets/icons/order/box.svg';
import Clipboard from '../../assets/icons/order/clipboard.svg';
import Shop from '../../assets/icons/order/shop.svg';
import Cards from '../../assets/icons/order/cards.svg';
import TextBox from '../../assets/icons/order/textBox.svg';
import Arrow from '../../assets/icons/arrow.svg';
import { GetOrders, customerFactor, GetTypeShekayat, SabtShekayat } from '../../utils/api';
import { Dropdown } from 'primereact/dropdown';
import Bag from '../../assets/icons/bag.svg';
import DiscountIcon from '../../assets/icons/order/discount.svg'
import Info from '../../assets/icons/order/info.svg'
function Orders({ onLoad }) {
    const toast = useRef(null);
    const [shouldOpenCalendar, setShouldOpenCalendar] = useState(false)
    const datePickerRef = useRef(null);
    const datePickerRef1 = useRef(null);
    const mobileDatePickerRef1 = useRef(null);
    const mobileDatePickerRef = useRef(null);
    const [fromDate, setFromDate] = useState(null);
    // const [toDate, setToDate] = useState(null);
    const [title, setTitle] = useState('');
    const [text, setText] = useState('');
    const [orderID, setOrderID] = useState('');
    const [totalAmount, setTotalAmount] = useState('');
    const [searchLoader, setSearchLoader] = useState(false);
    const [customerData, setCustomerData] = useState();
    const [visible, setVisible] = useState(false);
    const [dataOrders, setDataOrders] = useState('');
    const [factorListMap, setFactorListMap] = useState(new Map());
    const [validated, setValidated] = useState(false);
    const [loading, setLoading] = useState(false);
    const [productName, setProductName] = useState('');
    const [BranchName, setBranchName] = useState('');
    const [shekayatTypeData, setShekayatTypeData] = useState([]);
    const [shekayatTypeOption, setShekayatTypeOption] = useState([]);
    const [toDate, setToDate] = useState(null);
    const items = [{ label: 'سفارشات من' }];
    const home = { label: 'باشگاه مشتریان', url: '/' };
    const [date, setDates] = useState([
        new DateObject().setMonth(new Date().getMonth() - 5),
        new DateObject(),
    ])

    // isSettingTo uses only when the 'to date' datepicker opens to detect user's setting the 'to date' and prevent setting the 'from date' again.
    const [isSettingTo, setIsSettingTo] = useState(false);
    const [isSettingfrom, setIsSettingfrom] = useState(false);

    const onDateRangeChanged = (location, e) => {
        if (isSettingfrom) {
            handleFocus1()
            mobileHandleFocus1()
            closefromCalendar()
            mobileClosefromCalendar()
        } else if (!isSettingfrom && !isSettingTo) {
            handleFocus()
            mobileHandleFocus()
            closeToCalendar()
            mobileCloseToCalendar()
        }
        if (isSettingTo) {
            if (e[0].format().toString() == date[0].format().toString()) {
                setDates(e);
            } else {
                setDates((old) => {
                    old[1] = e[0];
                    return old;
                });
                setIsSettingTo(false);
            }


        }
        else {
            setDates(e);
        }
    };
    const onCalenderOpened = (e) => {

        if (e === 'to') {
            setIsSettingTo(true);
            setIsSettingfrom(false)
        }
        if (e === 'from') {
            setIsSettingfrom(true)
            setIsSettingTo(false);

        }

    };

    const formatDateObject = (dateObject) => {
        if (!dateObject) return "";
        const startDate = dateObject.split(' ~ ')[0];
        return startDate;
    };
    const formatDateObjectTo = (dateObject) => {
        if (!dateObject) return "";
        const endDate = dateObject.split(' ~ ')[1];
        return endDate;
    };
    const handleFocus = () => {
        if (datePickerRef.current) {
            datePickerRef.current.openCalendar();
        }
    };
    const closefromCalendar = () => {
        if (datePickerRef.current) {
            datePickerRef.current.closeCalendar();
        }
    };
    const closeToCalendar = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.closeCalendar();
        }
    };
    const mobileClosefromCalendar = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.closeCalendar();
        }
    };
    const mobileCloseToCalendar = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.closeCalendar();
        }
    };
    const handleFocus1 = () => {
        if (datePickerRef1.current) {
            datePickerRef1.current.openCalendar();
        }
    };
    const mobileHandleFocus = () => {
        if (mobileDatePickerRef.current) {
            mobileDatePickerRef.current.openCalendar();
        }
    };
    const mobileHandleFocus1 = () => {
        if (mobileDatePickerRef1.current) {
            mobileDatePickerRef1.current.openCalendar();
        }
    };
    // When the date range changes, update fromDate and toDate
    useEffect(() => {
        if (date && date.length === 2) {

            setFromDate(date[0]);
            setToDate(date[1]);
        }
    }, [date]);



    const showSuccess = (success) => {
        toast.current.show({ severity: 'success', detail: success.text, life: 3000 });
    }
    const showError = (error) => {
        toast.current.show({ severity: 'error', detail: error.text, life: 3000 });
    }
    const ordersData = async (pay) => {
        try {
            setSearchLoader(true)
            console.log('pay', pay)
            let res = await GetOrders(pay);
            console.log(res)
            if (res.status === 200) {
                getOrderData(res.data);
                setSearchLoader(false)
            }
        } catch (error) {
            setSearchLoader(true)
            // Handle the error appropriately, e.g., show an error message to the user, log it, etc.
        } finally {
            onLoad(); // Notify Home component that profile data is loaded
        }
    };

    const getOrderData = async (res) => {
        setDataOrders(res);
        let amount = 0
        res.forEach(async (order) => {
            amount += Number(order.TotalAmount);
            await getCustomerFactor(order.CustomerID, order.OrderID);
        });
        setTotalAmount(amount)
    };
    useEffect(() => {
        let customerDatares = window.localStorage.getItem('userInfo');
        setCustomerData(JSON.parse(customerDatares));
        let toDateNew = moment.now();
        let fd = new Date();
        fd.setMonth(fd.getMonth() - 6);
        let fromDateNew = fd;
        setToDate(toDateNew);
        setFromDate(fromDateNew);

        let pay = {
            FromDate: convertDateToPersian(fromDateNew),
            ToDate: convertDateToPersian(new Date()),
            CustomerId: JSON.parse(customerDatares).customerid,
            Kala: productName,
            Store: BranchName
        };

        ordersData(pay);
    }, []);

    useEffect(() => {
    }, [fromDate, toDate])

    const openCommentDialog = async (orderId) => {
        let shekayatType = await GetTypeShekayat();
        setShekayatTypeData(shekayatType.data);
        setOrderID(orderId);
        setVisible(true);
    };


    const convertDateToPersian = (date) => {
        if (!date) return '-';
        return moment(date).locale("fa").format("YYYY/MM/DD");
    };

    const getCustomerFactor = async (customerId, orderId) => {
        let pay = { customerId, orderId };
        let factorData = await customerFactor(pay); // This should be your API call returning factor data

        let mainProducts = new Map(); // A map to hold main products and their toppings
        let toppings = [];

        factorData.data.forEach((factor) => {
            if (factor.MainProduct === "0") {
                // This is a main product
                mainProducts.set(factor.ProductCode, { ...factor, toppings: [] });
            } else {
                // This is a topping
                toppings.push(factor);
            }
        });

        // Now assign toppings to their respective main products
        toppings.forEach((topping) => {
            if (mainProducts.has(topping.MainProduct)) {
                mainProducts.get(topping.MainProduct).toppings.push(topping);
            }
        });

        setOrderID(orderId);
        setFactorListMap((prevMap) => new Map(prevMap).set(orderId, Array.from(mainProducts.values())));
    };

    useEffect(() => {
    }, [factorListMap])
    const submitComment = async (event) => {
        event.preventDefault(); // Prevent the default form submission
        const form = event.currentTarget;
        if (form.checkValidity() === true) {
            event.stopPropagation();
            try {
                setLoading(true)
                let pay = {
                    matn: text,
                    shekayat: title.code,
                    orderId: orderID,
                    customerId: customerData.customerid
                };
                let response = await SabtShekayat(pay);
                if (response.data[0].Res === 'OK') {
                    setVisible(false)
                    setLoading(false)
                    showSuccess({ text: 'نظر شما با موفقیت ثبت شد.' });
                } else {
                    setLoading(false)
                    showError({ text: response.data[0].ResTp })
                }
            } catch (error) {
                setLoading(false)
            }

        }

        setValidated(true); // You may want to move this inside the if block, depending on your needs
    };

    const toPersianDateObject = (date) => {
        if (!date) return null;
    
        // اگر DateObject خود کتابخونه است
        if (date instanceof DateObject) {
            return date.convert(persian);
        }
    
        // اگر Date معمولی JS است
        if (date instanceof Date) {
            return new DateObject({
                date,
                calendar: persian,
                locale: persian_fa
            });
        }
    
        return null;
    };
    
    const searchOrder = async () => {
        if (!date?.[0]) {
            showError({ text: 'لطفا از تاریخ را انتخاب کنید.' });
            return;
        }
    
        const from = toPersianDateObject(date[0]);
        const to   = toPersianDateObject(date[1] ?? new Date());
    
        let payload = {
            FromDate: convertPersianDigitsToEnglish(
                from.format("YYYY/MM/DD")
            ),
            ToDate: convertPersianDigitsToEnglish(
                to.format("YYYY/MM/DD")
            ),
            Store: BranchName,
            Kala: productName,
            CustomerId: customerData.customerid
        };
    
        ordersData(payload);
    };
    
    useEffect(() => {
        let option = []
        if (!!shekayatTypeData &&
            shekayatTypeData.length > 0) {
            shekayatTypeData.map((type, index) => (
                option.push({
                    name: type.Shekayat,
                    code: type.si
                })
            ))
        }
        setShekayatTypeOption(option)
    }, [shekayatTypeData])


    function convertPersianDigitsToEnglish(text) {
        // Define a mapping of Persian digits to English digits
        const persianToEnglishDigits = {
            '۰': '0',
            '۱': '1',
            '۲': '2',
            '۳': '3',
            '۴': '4',
            '۵': '5',
            '۶': '6',
            '۷': '7',
            '۸': '8',
            '۹': '9'
        };

        // Use a regular expression to find Persian digits and replace them
        return text.replace(/[۰-۹]/g, function (match) {
            return persianToEnglishDigits[match];
        });
    }
    const weekDays = ["ش", "ی", "د", "س", "چ", "پ", "ج"]
    return (
        <div>
            <Toast ref={toast} />
            <BreadCrumb model={items} home={home} className='bread-crumb' />
            <div className='contain'>
                <div className='order-body'>
                    <div className='border-primary '>
                        <div className='web-filter d-flex align-items-center justify-content-between w-100'>
                            <Form className='flex-1 w-100'>

                                <div className='row'>
                                    <Form.Group className=" col-md-3 col-lg-3 col-sm-12">
                                        <Form.Label>از تاریخ</Form.Label>
                                        <DatePicker
                                            range
                                            numberOfMonths={2}
                                            showOtherDays
                                            value={date}
                                            onChange={(e) => onDateRangeChanged('from', e)}
                                            onOpen={() => onCalenderOpened('from')}
                                            calendar={persian}
                                            weekDays={weekDays}
                                            locale={persian_fa}
                                            render={(value) => {
                                                const fromDateFormatted = formatDateObject(value);
                                                return <input className='form-control f-1m' readOnly onFocus={handleFocus} value={fromDateFormatted} />;
                                            }}
                                            ref={datePickerRef}
                                            onClose={() => console.log()}
                                        />
                                    </Form.Group>
                                    <Form.Group className=" col-md-3 col-lg-3 col-sm-12">
                                        <Form.Label>تا تاریخ</Form.Label>
                                        <DatePicker
                                            range
                                            numberOfMonths={2}
                                            showOtherDays
                                            value={date}
                                            onChange={(e) => onDateRangeChanged('to', e)}
                                            onOpen={() => onCalenderOpened('to')}
                                            calendar={persian}
                                            weekDays={weekDays}
                                            locale={persian_fa}
                                            render={(value) => {
                                                const fromDateFormatted = formatDateObjectTo(value);
                                                return <input className='form-control f-1m' readOnly onFocus={handleFocus1} value={fromDateFormatted} />;
                                            }}
                                            ref={datePickerRef1}
                                            onClose={() => console.log()}
                                        />
                                        {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                                    </Form.Group>
                                    <Form.Group className=" col-md-3 col-lg-3 col-sm-12">
                                        <Form.Label>نام محصول</Form.Label>
                                        <Form.Control type="text" value={productName} onChange={(e) => setProductName(e.target.value)} />
                                    </Form.Group>
                                    <Form.Group className=" col-md-3 col-lg-3 col-sm-12">
                                        <Form.Label>شعبه</Form.Label>
                                        <Form.Control type="text" value={BranchName} onChange={(e) => setBranchName(e.target.value)} />
                                    </Form.Group>
                                </div>



                                <button type='button' disabled={searchLoader} className='btn btn-primary px-5 d-flex align-items-center justify-content-center gap-2 mt-3' style={{ float: 'left' }} onClick={searchOrder}> {searchLoader && <Loader />}جستجو</button>
                            </Form>
                        </div>
                        <div className='mobile-filter'>
                            <Accordion activeIndex={0}>
                                <AccordionTab
                                    header={
                                        <span className="d-flex align-items-center justify-content-between py-4 gap-2 w-full">
                                            <span style={{ fontSize: '14px', fontWeight: '700' }}>فیلترها</span>
                                            <i className="pi pi-sliders-h"></i>
                                        </span>
                                    }
                                >
                                    <Form className='row'>
                                        <Form.Group className=" col-md-4 col-lg-4 col-sm-12">
                                            <Form.Label>از تاریخ</Form.Label>
                                            <DatePicker
                                                range
                                                numberOfMonths={2}
                                                showOtherDays
                                                value={date}
                                                onChange={(e) => onDateRangeChanged('from', e)}
                                                onOpen={() => onCalenderOpened('from')}
                                                calendar={persian}
                                                weekDays={weekDays}
                                                locale={persian_fa}
                                                render={(value) => {
                                                    const fromDateFormatted = formatDateObject(value);
                                                    return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus} value={fromDateFormatted} />;
                                                }}
                                                ref={mobileDatePickerRef}
                                                onClose={() => console.log()}
                                            />
                                        </Form.Group>
                                        <Form.Group className=" col-md-4 col-lg-4 col-sm-12 mt-2">
                                            <Form.Label>تا تاریخ</Form.Label>
                                            <DatePicker
                                                range
                                                numberOfMonths={2}
                                                showOtherDays
                                                value={date}
                                                onChange={(e) => onDateRangeChanged('to', e)}
                                                onOpen={() => onCalenderOpened('to')}
                                                calendar={persian}
                                                weekDays={weekDays}
                                                locale={persian_fa}
                                                render={(value) => {
                                                    const fromDateFormatted = formatDateObjectTo(value);
                                                    return <input className='form-control f-1m' readOnly onFocus={mobileHandleFocus1} value={fromDateFormatted} />;
                                                }}
                                                ref={mobileDatePickerRef1}
                                                onClose={() => console.log()}
                                            />
                                            {/* <DatePicker
                                    // readOnly
                                    value={toDate}
                                    // onChange={setDates}
                                    calendar={persian}
                                    locale={persian_fa}
                                /> */}
                                        </Form.Group>
                                        <Form.Group className=" col-md-4 col-lg-4 col-sm-12 mt-2">
                                            <Form.Label>نام محصول</Form.Label>
                                            <Form.Control type="text" value={productName} onChange={(e) => setProductName(e.target.value)} />
                                        </Form.Group>
                                        <Form.Group className=" col-md-4 col-lg-4 col-sm-12 mt-2">
                                            <Form.Label>شعبه</Form.Label>
                                            <Form.Control type="text" value={BranchName} onChange={(e) => setBranchName(e.target.value)} />
                                        </Form.Group>
                                    </Form>
                                    <button type='button' disabled={searchLoader} className='btn btn-primary w-100 mt-3 px-5 d-flex align-items-center justify-content-center gap-2' onClick={searchOrder}> {searchLoader && <Loader />}جستجو</button>
                                </AccordionTab>
                            </Accordion>
                        </div>
                    </div>
                    <div className='border-primary mt-4'>
                        <div className='totals d-flex align-items-center justify-content-between'>
                            <div style={{ color: "#538c0e" }} >
                                مبلغ کل سفارشات در این بازه: <span className='number' style={{ fontWeight: '600' }}>{totalAmount.toLocaleString()}</span> ریال
                            </div>
                            <div style={{ color: "#538c0e" }} >
                                تعداد کل سفارشات در این بازه: <span className='number' style={{ fontWeight: '600' }}>{dataOrders.length}</span>
                            </div>
                        </div>
                    </div>

                    {(!!dataOrders && dataOrders.length > 0) && dataOrders.map((order) =>
                        <div className='border-primary mt-2 pt-4' key={order.OrderID}>
                            <div className='row gy-4'>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Factor} alt="" />
                                    <h6 className='m-0 f-14 number'>شماره فاکتور: {order.OrderID}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Calendar} alt="" />
                                    <h6 className='m-0 f-14 number'>تاریخ فاکتور: {order.DateKharid}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Box} alt="" />
                                    <h6 className='m-0 f-14 number'> تعداد کالا: {order.NqRow}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Clipboard} alt="" />
                                    <h6 className='m-0 f-14 number'>تعداد اقلام فاکتور: {order.NqKala}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Cards} alt="" />
                                    <h6 className='m-0 f-14 number'>مبلغ فاکتور: {parseInt(order.TotalAmount).toLocaleString()} ریال</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Shop} alt="" />
                                    <h6 className='m-0 f-14'>شعبه: {(order.StoreName).replace(/\d+/g, '')}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={Bag} alt="" />
                                    <h6 className='m-0 f-14'>مرجع ثبت سفارش: {order.Source}</h6>
                                </div>
                                <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                    <img src={DiscountIcon} alt="" />
                                    <h6 className='m-0 f-14 number'>میزان تخفیف: {parseInt(order.DiscountAmount).toLocaleString()} ریال</h6>
                                </div>
                            </div>
                            <div className='mt-5'>
                                <Accordion activeIndex={-1}>
                                    <AccordionTab header='اطلاعات بیشتر'>
                                        {factorListMap.get(order.OrderID) && factorListMap.get(order.OrderID)?.map((factor, index) => (
                                            <div key={order.OrderID + '-' + factor.ProductCode}>
                                                <div className='row gy-4'>
                                                    <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                        <img src={Factor} alt="" />
                                                        <h6 className='m-0 f-14 number'>کد کالا: {factor.ProductCode}</h6>
                                                    </div>
                                                    <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                        <img src={TextBox} alt="" />
                                                        <h6 className='m-0 f-14 number'>نام کالا: {factor.KalaName}</h6>
                                                    </div>
                                                    <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                        <img src={Box} alt="" />
                                                        <h6 className='m-0 f-14 number'> تعداد کالا: {factor.OrderCount}</h6>
                                                    </div>
                                                    <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                        <img src={Cards} alt="" />
                                                        <h6 className='m-0 f-14 number'>قیمت کل: {factor.Price} ریال</h6>
                                                    </div>
                                                </div>

                                                {/* Check if toppings exist and are an array */}
                                                {Array.isArray(factor.toppings) && factor.toppings.length > 0 && (
                                                    <>
                                                        <div className="toping-list d-flex mt-2 gap-3  mx-3">
                                                            <img src={Arrow} />
                                                            <div className='flex-1 w-100'>

                                                                {factor.toppings.map((topping) => (
                                                                    <div key={topping.ProductCode} className='row  gy-4 w-100 mt-1 '>

                                                                        <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                                            <img src={Factor} alt="" />
                                                                            <h6 className='m-0 f-14 number'>کد تاپینگ: {topping.ProductCode}</h6>
                                                                        </div>
                                                                        <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                                            <img src={TextBox} alt="" />
                                                                            <h6 className='m-0 f-14 number'>نام تاپینگ: {topping.KalaName}</h6>
                                                                        </div>
                                                                        <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                                            <img src={Box} alt="" />
                                                                            <h6 className='m-0 f-14 number'> تعداد تاپینگ: {topping.OrderCount}</h6>
                                                                        </div>
                                                                        <div className='col-md-3 col-sm-12 d-flex align-items-center gap-2'>
                                                                            <img src={Cards} alt="" />
                                                                            <h6 className='m-0 f-14 number'>قیمت کل: {topping.Price} ریال</h6>
                                                                        </div>
                                                                    </div>
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </>
                                                )}

                                                {index < factorListMap.get(order.OrderID).length - 1 && <hr className="dashed-2" />}
                                            </div>
                                        ))}

                                    </AccordionTab>
                                </Accordion>
                            </div>
                            {order.Source == 'اسنپ فود' ? (
                                <h6 className='w-100 d-flex align-items-center justify-content-end gap-2 mb-0' style={{ textAlign: 'left', fontSize: '14px', color: '#669d24' }}><img src={Info} /> لطفا برای ثبت نظر، به سفارش خود در اسنپ فود مراجعه کنید.</h6>

                            ) : (
                                <div className='w-100' style={{ textAlign: 'left' }}>
                                    <button className='btn btn-primary mt-3' onClick={() => openCommentDialog(order.orderID)}>ثبت نظر</button>
                                </div>
                            )}
                        </div>
                    )}


                </div>
            </div>

            <Dialog
                header="ثبت نظر"
                visible={visible}
                onHide={() => {
                    if (!visible) return;
                    setVisible(false);
                }}
                style={{ width: '400px' }}
                breakpoints={{ '200px': '200px', '200px': '90vw' }}
            >
                <hr className="my-0" style={{ color: '#669d24 !important', borderWidth: '3px' }} />
                <Form noValidate validated={validated} onSubmit={submitComment} className="row gx-5 mb-4 mt-3">
                    <Form.Group className="mb-3 col-12">
                        <Form.Label>
                            نوع نظر <span style={{ color: 'red' }}>*</span>
                        </Form.Label>
                        <Dropdown value={title} onChange={(e) => setTitle(e.value)} options={shekayatTypeOption} optionLabel="name"
                            className="w-100 " />

                        <Form.Control.Feedback type="invalid">
                            لطفا نوع نظر را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>

                    <Form.Group className="mb-3 col-12">
                        <Form.Label>
                            متن نظر <span style={{ color: 'red' }}>*</span>
                        </Form.Label>
                        <Form.Control
                            type="text"
                            as="textarea"
                            rows={3}
                            required
                            value={text}
                            onChange={(e) => setText(e.target.value)}
                        />
                        <Form.Control.Feedback type="invalid">
                            لطفا متن نظر را وارد کنید
                        </Form.Control.Feedback>
                    </Form.Group>
                    <button disabled={loading} type="submit" className="btn btn-primary mt-3 mx-auto d-flex align-items-center justify-content-center gap-2" style={{ width: '90%' }}>
                        {loading && <Loader />}ثبت
                    </button>
                </Form>
            </Dialog>
        </div>
    );
}

export default Orders;
